
//******************Exchange Rate Server Calls******************;

import {PointsHistoryActions} from './PointsHistoryConstants';
import store from '../../../Store/store'
import {ROOT_URL,getCookie} from '../../../Config/Config';
import {failure_messages} from "Messages"


export const PointsHistoryServer = {
  getPointsHistoryByUserId:getPointsHistoryByUserId,
  getRiderAnsweredQuestions:getRiderAnsweredQuestions
};

//******************Insert PointsHistorys******************;

function getPointsHistoryByUserId(data){
  // data.props.setLoading(true)
      const request=fetch(ROOT_URL+'/api/customer/getPointsHistoryByUserId', {
          method: 'Post',
          mode: 'cors',
          headers: { 
            'authorization':getCookie("admin_token_customer"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
          }).then((response)=>{
           response.json().then(response=>{
             if(response.status == "200"){
              // data.props.setLoading(false)
          // alert(response.count)
              // if(data.props.setQuestionList && data.props.activePage == 1){
              //   data.props.setQuestionList(response.QuestionsCount)
              // }
            store.dispatch({type:PointsHistoryActions.PointsHistory_GET.SUCCESS,payload:response.data, PointsCount:response.count})// , QuestionsCount:response.QuestionsCount});
            return ;
            }else
            {
              // data.props.setLoading(false)
              store.dispatch({type:PointsHistoryActions.PointsHistory_GET.FAILED, error:response.error});
              return ;
              }    
           });
          }).catch((error) => {
            // if(data.props.setQuestionList){
            //   data.props.setQuestionList(0)
            // }
            // data.props.setLoading(false)
           store.dispatch({type:PointsHistoryActions.PointsHistory_GET.FAILED, error:failure_messages.unExpectedError});
            })
      return {type:PointsHistoryActions.PointsHistory_GET.LOADING}

};
  

function getRiderAnsweredQuestions(data){
  // alert(JSON.stringify(data))
  const request=fetch(ROOT_URL+'/api/support/getRiderAnsweredQuestions', {
      method: 'Post',
      mode: 'cors',
      headers: { 
        'authorization':getCookie("admin_token_customer"),
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
      }).then((response)=>{
       response.json().then(response=>{
         if(response.status == "200"){
         // alert(JSON.stringify(response))
        store.dispatch({type:PointsHistoryActions.PointsHistory_GET.SUCCESS,payload:response.data, QuestionsCount:response.QuestionsCount});
        return ;
        }else
        {
          store.dispatch({type:PointsHistoryActions.PointsHistory_GET.FAILED, error:response.error});
          return ;
          }    
       });
      }).catch((error) => {
      //  alert(error)
       store.dispatch({type:PointsHistoryActions.PointsHistory_GET.FAILED, error:failure_messages.Businessparticipants});
        })
  return {type:PointsHistoryActions.PointsHistory_GET.LOADING}

};
